import {
  apiClient,
  type AutoCalculateIncomeEntity,
  type AutoCalculateIncomeDto
} from '@/libs/api'

export type autoCalculateIncomeRequest = {
  tenantKey: string
  dto: AutoCalculateIncomeDto
}

export const autoCalculateIncome = async ({
  tenantKey,
  dto
}: autoCalculateIncomeRequest): Promise<AutoCalculateIncomeEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.auto_calculate_income.$post({ body: dto })

  return data
}
